export type StaffMultiEditorTabId =
    | 'info'
    | 'business-info'
    | 'role-permissions'
    | 'hours-pay'
    | 'notifications'
    | 'advanced-settings';

export type StaffMultiEditorTab = {
    id: StaffMultiEditorTabId;
    label: string;
};

export const STAFF_MULTI_EDITOR_TABS: StaffMultiEditorTab[] = [
    { id: 'info', label: 'Info' },
    { id: 'business-info', label: 'Staff Business Information' },
    { id: 'role-permissions', label: 'Role & Permissions' },
    { id: 'hours-pay', label: 'Hours & Pay' },
    { id: 'notifications', label: 'Notifications' },
    { id: 'advanced-settings', label: 'Advanced Settings' },
];

export const DEFAULT_STAFF_MULTI_EDITOR_TAB: StaffMultiEditorTabId = 'info';

export const EDITABLE_STAFF_MULTI_EDITOR_TAB_IDS: StaffMultiEditorTabId[] =
    STAFF_MULTI_EDITOR_TABS.map((tab) => tab.id);

export const isEditableStaffMultiEditorTab = (
    tabId: string,
): tabId is StaffMultiEditorTabId =>
    EDITABLE_STAFF_MULTI_EDITOR_TAB_IDS.includes(
        tabId as StaffMultiEditorTabId,
    );
